import React from "react";
import { Row, Table, Modal, Button, Spin, Icon, Layout } from "antd";

import jwtDecode from "jwt-decode";
import { Constant } from "../../../config/index";

import services from "../../BlackList/services";
import getColumn from "../../BlackList/column";
import DataInputModal from "../../BlackList/modals/filledModal";
import FilterForm from "../../BlackList/form";

const { Content } = Layout;

class BlackListModal extends React.Component {
  state = {
    loading: false,
    dataSource: [],
    adminList: [],
    defaultSearch: null,
    showInputModal: false,
    currentData: {},
    visible: false,
    title: "",
    memberData: {},
  };

  currentPage = 1;
  currentSearch = "";
  limit = 10;
  totalRows = 0;

  async componentDidMount() {
    const { data, visible } = this.props;
    const adminList = await services.getAdminLists();
    const defaultSearch = { member_id: data.memberId };
    this.currentSearch = JSON.stringify(defaultSearch);
    const { totalRows, dataSource } = await services.getBlackList(
      this.currentPage,
      this.limit,
      this.currentSearch
    );

    this.totalRows = totalRows;

    this.setState({
      loading: false,
      dataSource,
      adminList: adminList.list,
      defaultSearch,
      title: "Blacklist ของ " + data.memberName,
      visible,
      memberData: data,
    });
  }

  changePage = async (page, limit) => {
    this.setState({ loading: true });
    this.currentPage = page;
    this.limit = limit;

    const { dataSource, totalRows } = await services.getBlackList(
      page,
      limit,
      this.currentSearch
    );

    if (totalRows > 0 && dataSource.length === 0) {
      this.changePage(1, this.limit);
      this.setState({ loading: false });
    }

    this.totalRows = totalRows;
    this.setState({
      dataSource,
      loading: false,
    });
  };

  toggleStatus = async (value, record) => {
    const d = jwtDecode(localStorage.getItem(Constant.SessionKey));
    const convStatus = {
      true: "enabled",
      false: "disabled",
      delete: "deleted",
    };
    const preparedValue = {
      ...record,
      status: convStatus[value],
      updated_by: d["id"],
    };

    delete preparedValue.created_by;

    const resp = await services.updateBlackList(preparedValue);
    const result = services.handlerError(resp);
    if (!result) {
      return;
    }
    this.changePage(this.currentPage, this.limit);
  };

  handlerEdit = (record) => {
    this.setState({
      showInputModal: true,
      currentData: record,
    });
  };

  afterFormSubmit = (value) => {
    let tmp;
    if (value) {
      tmp = JSON.parse(value);
      tmp = { ...this.state.defaultSearch, ...tmp };

      if (tmp["created_by"]) {
        tmp["created_by"] = `${tmp["created_by"]}`;
      }
    } else {
      tmp = this.state.defaultSearch;
    }
    //add memberid = 1;

    this.currentSearch = JSON.stringify(tmp);
    this.changePage(this.currentPage, this.limit);
  };

  handleOnClickAdding = () => {
    this.setState({
      showInputModal: true,
    });
  };

  handleOnCloseModalInput = async (_, succeed) => {
    if (succeed) {
      await this.changePage(this.currentPage, this.limit);
    }

    this.setState({
      showInputModal: false,
      currentData: {},
    });
  };

  render() {
    const { onCancel } = this.props;
    const propsTable = {
      className: "my-table",
      columns: getColumn(this.toggleStatus, this.handlerEdit),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.totalRows,
        current: this.currentPage,
        onChange: this.changePage,
        size: "small",
      },
    };

    return (
      <Modal
        className="my-layout"
        visible={this.state.visible}
        maskClosable={false}
        onCancel={onCancel}
        title={this.state.title}
        width={1200}
        footer={null}
        style={{ top: 20 }}
      >
        <Layout className="my-layout">
          <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
            <FilterForm
              adminList={this.state.adminList}
              onSubmit={(v) => this.afterFormSubmit(v)}
            />
            <Content
              style={{
                background: "#fff",
                padding: 24,
                margin: "16px 0",
                minHeight: 300,
              }}
            >
              <Row className="utility-bar-mobile"></Row>
              <div style={{ textAlign: "end" }}>
                <Button onClick={this.handleOnClickAdding}>
                  <Icon type="plus-circle" /> เพิ่มรายการ
                </Button>
              </div>

              <Table style={{ marginTop: "8px" }} {...propsTable} />
            </Content>
            {this.state.showInputModal && (
              <DataInputModal
                data={this.state.currentData}
                onClose={this.handleOnCloseModalInput}
                visible={this.state.showInputModal}
                memberId={this.state.memberData.memberId}
              />
            )}
          </Spin>
        </Layout>
      </Modal>
    );
  }
}

export default BlackListModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/BlackListMemberModal.js